module.exports = __webpack_public_path__ + "static/media/invite.74ff0757.svg";